<template>
  <div>
    <div v-if="focus && focus.state === 'ondeck'">
      <div style="display: flex">
        Connect - Requires a Freight Account
      </div>
      <div style="display: flex" class="mt-3 mb-2">
        <input v-model="username" placeholder="username..." />
      </div>
      <div style="display: flex" class="mb-2">
        <input v-model="token" placeholder="token..." />
      </div>
      <div style="display: flex">
        <button @click="saveSetting">Connect!</button>
      </div>
    </div>

    <div v-if="focus && focus.state === 'ontrack'" style="padding: 0">
      <div>
        <div style="display: flex">
          <div style="width:100%">
            <img :src="imgSrc" style="height:auto;width:100%" />
          </div>
        </div>
        <div style="display: flex" class="my-3">
          <div>
            <input
              placeholder="your code here.."
              v-model="codeInput"
              style="width:100px"
            />
          </div>
          <button @click="handleSearchImg">Search</button>
        </div>
        <div
          style="display: flex;width: 100%; position:relative; margin:0; padding: 0; margin-bottom: 12px"
        >
          <!-- <div class="w-100 p-0 m-0" style="border: 1px solid #e1e1e2; height: 100px"> -->
          <file-pond
            style="width: 100%"
            name="toUpload"
            ref="toUpload"
            label-idle="Drop files here..."
            accepted-file-types="image/jpeg, image/png"
          />
          <!-- v-on:init="handleFilePondChange" -->
          <!-- server="/api" -->
          <!-- v-bind:allow-multiple="true" -->
          <!-- </div> -->
          <div
            v-if="imgCode"
            style="position: absolute; right:0;top:0; background-color: #272f75; border: 1px solid #e1e1e2;padding:10px; border-radius: 10px; color: white;"
          >
            {{ imgCode }}
          </div>
        </div>
        <div style="display: flex; justify-content: center;">
          <button @click="uploadImage">Upload</button>
        </div>
      </div>
    </div>

    <div v-if="focus && focus.state === 'stationed'">
      STATIONED
    </div>
  </div>
</template>
<script>
import "./filepond.min.css";
import "./filepond-plugin-image-preview.min.css";

// const { FilePond } = window.FilePond;

export default {
  name: "freight-web-component",
  components: {
    // FilePond
  },
  props: {
    tool: {
      type: Object,
      required: false,
      default: () => {}
    },
    focus: {
      type: Object,
      required: false,
      default: () => {}
    },
    user: {
      type: String,
      default: () => ""
    },
    setTracker: {
      type: Function,
      default: () => () => {}
    },
    setSetting: {
      type: Function,
      default: () => () => {}
    }
  },
  methods: {
    saveSetting() {
      // this.$store.dispatch('tools/addFreightSetting', {freight: {_created_at: new Date(), token: this.token, username: this.username}, focusId: this.focus.focusId, tools_id: this.tool.tools_id})
      this.setSetting({
        freight: {
          _created_at: new Date(),
          token: this.token,
          username: this.username
        },
        focusId: this.focus.focusId,
        tools_id: this.tool.tools_id
      });
    },

    handleSearchImg() {
      if (
        this.tool.tracks &&
        this.tool.tracks.goods &&
        this.tool.tracks.goods.length
      ) {
        this.tool.tracks.goods.forEach(el => {
          if (el.code === this.codeInput) {
            this.imgSrc = el.imgURL;
          }
        });
      }
    },
    uploadImage() {
      let code = Math.floor(Math.random() * (10 - 1 + 1)) + 1 + this.makeid(4);
      this.imgCode = code;

      let files = this.$refs.toUpload.getFiles();
      if (files.length) {
        this.setTracker(files[0].file, code);
      }
    },
    makeid(length) {
      var result = "";
      var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    }
  },
  computed: {},
  mounted() {
    if (
      this.tool &&
      this.tool.settings &&
      this.tool.settings.freight &&
      this.tool.settings.freight.length
    ) {
      this.token = this.tool.settings.freight[
        this.tool.settings.freight.length - 1
      ].token;
      this.username = this.tool.settings.freight[
        this.tool.settings.freight.length - 1
      ].username;
    }
  },
  data: function() {
    return {
      showTracking: false,
      options: {
        fullWidth: !0,
        chartPadding: {
          right: 15,
          left: -15
        },
        low: 0,
        showArea: true
      },
      // ondeck view state
      username: "",
      token: "",
      // ontrack view state
      toUpload: null,
      imgCode: "",
      imgSrc: "",
      codeInput: ""
    };
  }
};
</script>
<style lang="scss" module>
@import "./style.module.scss";
</style>
<style scoped>
.card-body {
  overflow-y: auto;
}
</style>
<style>
@import "./filepond.min.css";
@import "./filepond-plugin-image-preview.min.css";
</style>
